var g = Object.defineProperty;
var m = (c, r, e) => r in c ? g(c, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : c[r] = e;
var u = (c, r, e) => (m(c, typeof r != "symbol" ? r + "" : r, e), e);
const C = (c, r, e = !0, t, s, n, a) => {
  let i = new URL(`${c}/${t}`);
  const o = {
    "Client-Key": `${n}`,
    ...s && { Authorization: `Bearer ${s}` }
  };
  return e && (o["content-type"] = "application/json"), fetch(`${i}`, {
    method: r,
    headers: o,
    body: a && JSON.stringify(a)
  });
}, $ = () => {
  const c = {}, r = (t) => (s) => {
    c[t] = s;
  }, e = (t, s) => () => c[t] ?? s;
  return {
    // initialinze
    getClient: e("appClient"),
    setClient: r("appClient"),
    getHost: e("appHost"),
    setHost: r("appHost"),
    getAppKey: e("appId"),
    setAppKey: r("appId"),
    // auth login
    setAuthLogin: r("AuthLogin"),
    getAuthLogin: e("AuthLogin"),
    // auth register
    setAuthRegister: r("AuthRegister"),
    getAuthRegister: e("AuthRegister"),
    //Post
    setPost: r("Post"),
    getPost: r("Post"),
    //Client
    setClientId: r("Client"),
    getClientId: e("Client")
  };
};
class d {
  constructor() {
    u(this, "storage", $());
  }
  get client() {
    return this.storage.getClient();
  }
  get host() {
    return this.storage.getHost();
  }
  get AppKey() {
    return this.storage.getAppKey();
  }
  init({ client: r, host: e, AppKey: t }) {
    this.storage.setClient(r), this.storage.setHost(e), this.storage.setAppKey(t);
  }
  // setup authorization for headers
  async apiCall(r, e, t, s) {
    const n = this.host, a = this.client, i = this.AppKey;
    try {
      const o = await C(n, r, t, e, i, a, s);
      if (o)
        return await o.json();
    } catch (o) {
      return o;
    }
  }
  /* Client API */
  async getClient() {
    try {
      const r = await this.apiCall("GET", "clients");
      if (r)
        return r.data;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getClientPermissions() {
    try {
      const r = await this.apiCall("GET", "clients/permissions");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getCLientAppreanceConfig() {
    try {
      const r = await this.apiCall("GET", "clients/appreance/config/website");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getFirebaseAppServiceAccount() {
    try {
      const r = await this.apiCall("GET", "clients/firebase/appserviceaccount");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getSettingPolicies() {
    try {
      const r = await this.apiCall("GET", "clients/settings/policies");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  /* Authentication API */
  async LoginWithEmail({ login: r, password: e }) {
    const t = {
      login: r,
      password: e,
      grant_type: "password"
    };
    try {
      const s = await this.apiCall("POST", "auth/access_token", !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async resetPassword({ code: r, password: e }) {
    const t = {
      code: r,
      password: e
    };
    try {
      const s = await this.apiCall("POST", "auth/reset", !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async forgotPassword({ url: r, email: e }) {
    const t = {
      url: r,
      email: e
    };
    try {
      const s = await this.apiCall("POST", "auth/forgot", !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async sendOTP({ email: r }) {
    const e = {
      email: r
    };
    try {
      const t = await this.apiCall("POST", "verification/send", !0, {
        ...e
      });
      if (t)
        return t;
      throw new Error();
    } catch (t) {
      return t;
    }
  }
  async resendOTP({ email: r }) {
    const e = {
      email: r
    };
    try {
      const t = await this.apiCall("POST", "verification/resend", !0, {
        ...e
      });
      if (t)
        return t;
      throw new Error();
    } catch (t) {
      return t;
    }
  }
  async verifyOTP({ email: r, code: e }) {
    const t = {
      email: r,
      code: e
    };
    try {
      const s = await this.apiCall("POST", "verification/verify", !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async changePassword({ password: r, password_confirmation: e, code: t }) {
    const s = {
      password: r,
      password_confirmation: e,
      code: t
    };
    try {
      const n = await this.apiCall("POST", "reset/password", !0, {
        ...s
      });
      if (n)
        return n;
      throw new Error();
    } catch (n) {
      return n;
    }
  }
  async LoginWithSSO({ token: r }) {
    const e = {
      token: r,
      grant_type: "sso"
    };
    try {
      const t = await this.apiCall("POST", "auth/access_token", !0, {
        ...e
      });
      if (t)
        return t;
      throw new Error();
    } catch (t) {
      return t;
    }
  }
  async RegisterWithEmail({ name: r, email: e, phone: t, password: s, password_confirmation: n }) {
    const a = {
      name: r,
      email: e,
      phone: t,
      password: s,
      password_confirmation: n,
      grant_type: "password"
    };
    try {
      const i = await this.apiCall("POST", "auth/register", !0, {
        ...a
      });
      if (i)
        return i;
      throw new Error();
    } catch (i) {
      return i;
    }
  }
  async subscribeMember({ name: r, email: e }) {
    const t = {
      name: r,
      email: e
    };
    try {
      const s = await this.apiCall("POST", "members/subscribe", !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async checkUsers() {
    try {
      const r = await this.apiCall("POST", "checks/users");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getProfile() {
    try {
      const r = await this.apiCall("GET", "me");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async updateProfile({ name: r, email: e, phone: t, member: s, avatar: n }) {
    const a = {
      name: r,
      email: e,
      phone: t,
      member: s,
      avatar: n
    };
    try {
      const i = await this.apiCall("PUT", "me", !0, {
        ...a
      });
      if (i)
        return i;
      throw new Error();
    } catch (i) {
      return i;
    }
  }
  /* Membership API */
  async getProfileMembership() {
    try {
      const r = await this.apiCall("GET", "profile/membership");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getProfileMembershipPackage() {
    try {
      const r = await this.apiCall("GET", "profile/membership/package");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getPackagesMembership() {
    try {
      const r = await this.apiCall("GET", "members/packages");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async CheckNumberVerifyMembership(r) {
    try {
      const e = await this.apiCall("POST", "memberships/check", !0, {
        number: r
      });
      if (e)
        return e;
      throw new Error();
    } catch (e) {
      return e;
    }
  }
  async VerifyMembership({ name: r, email: e, phone: t, address: s, number: n }) {
    try {
      const a = await this.apiCall("POST", `memberships/verify/${n}`, !0, {
        name: r,
        email: e,
        phone: t,
        address: s
      });
      if (a)
        return a;
      throw new Error();
    } catch (a) {
      return a;
    }
  }
  async RegistrationEvent({ id: r, name: e, email: t, phone: s, form_response: n, package_id: a, qty: i, payment_method_id: o, rsvp_data: l }) {
    try {
      const p = await this.apiCall("POST", `events/${r}/rsvp`, !0, {
        name: e,
        email: t,
        phone: s,
        package_id: a,
        qty: i,
        form_response: n,
        payment_method_id: o,
        rsvp_data: l
      });
      if (p)
        return p;
      throw new Error();
    } catch (p) {
      return p;
    }
  }
  /* Event API */
  async getEvent(r, e, t, s, n, a, i) {
    try {
      let o = "";
      r && (o += `&category=${r}`), e && (o += `&page=${e}`), t && (o += `&pageNumber=${t}`), s && (o += `&q=${s}`), n && (o += `&theme=${n}`), a && (o += `&type=${a}`), i && (o += `&eventDate=${i}`);
      const l = await this.apiCall("GET", `events?${o}`);
      if (l)
        return l;
    } catch (o) {
      console.log(o);
    }
  }
  async getUpcomingEvent(r, e) {
    try {
      let t = "";
      r && (t += `&pageNumber=${r}`), e && (t += `&page=${e}`);
      const s = await this.apiCall("GET", `events/upcoming?${t}`);
      if (s)
        return s.data;
    } catch (t) {
      console.log(t);
    }
  }
  async getEventDetail(r) {
    try {
      const e = await this.apiCall("GET", `events/${r}`);
      if (e)
        return e.data;
      throw new Error();
    } catch (e) {
      return e;
    }
  }
  async getThemesEvent() {
    try {
      const r = "events/categories", e = await this.apiCall("GET", `${r}`);
      if (e)
        return e.data;
    } catch (r) {
      return r;
    }
  }
  async getCategoriesEvents(r, e, t, s) {
    try {
      let n = "";
      t && (n += `&category=${t}`), r && (n += `&pageNumber=${r}`), e && (n += `&page=${e}`), s && (n += `&q=${s}`);
      const a = await this.apiCall("GET", `events?${n}`);
      if (a)
        return a;
    } catch (n) {
      console.log(n);
    }
  }
  async CreateMembership({ division_id: r, package_id: e, custom_attributes: t, payment_method_id: s }) {
    try {
      const n = await this.apiCall("POST", "members/membership", !0, {
        division_id: r,
        package_id: e,
        custom_attributes: t,
        payment_method_id: s
      });
      if (n)
        return n;
      throw new Error();
    } catch (n) {
      return n;
    }
  }
  async getRsvpsDetail(r) {
    try {
      const e = await this.apiCall("GET", `events/rsvps/${r}`);
      if (e)
        return e;
    } catch (e) {
      console.log(e);
    }
  }
  async getListPackageEvent(r) {
    try {
      const e = await this.apiCall("GET", `events/${r}/packages`);
      if (e)
        return e;
    } catch (e) {
      console.log(e);
    }
  }
  /* Transactions API */
  async getPaymentChannels({ amount: r }) {
    const e = {
      amount: r
    };
    try {
      const t = await this.apiCall("POST", "payments/channels", !0, {
        ...e
      });
      if (t)
        return t;
      throw new Error();
    } catch (t) {
      return t;
    }
  }
  async getListPaymentChannels(r, e, t) {
    try {
      const s = await this.apiCall("GET", `payments/channels/${r}/${e}?amount=${t}`);
      if (s)
        return s;
    } catch (s) {
      console.log(s);
    }
  }
  async getInvoicesDetail(r) {
    try {
      const e = await this.apiCall("GET", `invoices/${r}`);
      if (e)
        return e;
    } catch (e) {
      console.log(e);
    }
  }
  async updateInvoiceStatus({ hash: r, status: e }) {
    const t = {
      status: e
    };
    try {
      const s = await this.apiCall("PUT", `invoices/status/${r}`, !0, {
        ...t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  /* News API */
  async getPosts(r, e, t = "") {
    try {
      let s = "";
      r && (s += `&page=${r}`), e && (s += `&q=${e}`), t && (s += `&exclude=${t}`);
      const n = await this.apiCall("GET", `news?pageNumber=8${s}`);
      if (n)
        return n;
    } catch (s) {
      console.log(s);
    }
  }
  async getLatestPosts(r, e = "") {
    try {
      let t = "";
      r && (t += `&page=${r}`), e && (t += `&exclude=${e}`);
      const s = await this.apiCall("GET", `news?pageNumber=4${t}`);
      if (s)
        return s;
    } catch (t) {
      console.log(t);
    }
  }
  async getPostsDetail(r) {
    try {
      const e = await this.apiCall("GET", `news/${r}`);
      if (e)
        return e.data;
    } catch (e) {
      return e;
    }
  }
  async getCategoriesPost(r, e, t, s, n = "") {
    try {
      let a = "";
      t && (a += `&category=${t}`), r && (a += `&pageNumber=${r}`), e && (a += `&page=${e}`), s && (a += `&q=${s}`), n && (a += `&exclude=${n}`);
      const i = await this.apiCall("GET", `news?${a}`);
      if (i)
        return i;
    } catch (a) {
      console.log(a);
    }
  }
  async getPostsCategories() {
    try {
      const r = "news/categories", e = await this.apiCall("GET", `${r}`);
      if (e)
        return e.data;
    } catch (r) {
      return r;
    }
  }
  /* Vacancies */
  async getVacancies(r) {
    try {
      const e = await this.apiCall("GET", `vacancies?pageNumber=${r}`);
      if (e)
        return e.data;
      throw new Error();
    } catch (e) {
      return e;
    }
  }
  async getFilterVacancies(r, e, t, s, n) {
    try {
      let a = "";
      r && (a += `category=${r}`), e && (a += `&industry=${e}`), t && (a += `&type=${t}`), s && (a += `&q=${s}`), n && (a += `&page=${n}`);
      const i = await this.apiCall("GET", `vacancies?${a}`);
      if (i)
        return i;
    } catch (a) {
      console.log(a);
    }
  }
  async getVacanciesCategories() {
    try {
      const r = await this.apiCall("GET", "vacancies/categories");
      if (r)
        return r.data;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  async getVacanciesTypes() {
    try {
      const r = await this.apiCall("GET", "vacancies/types");
      if (r)
        return r.data;
    } catch (r) {
      return r;
    }
  }
  async getIndustries() {
    try {
      const r = await this.apiCall("GET", "vacancies/industries");
      if (r)
        return r.data;
    } catch (r) {
      return r;
    }
  }
  async getDetailVacancy(r) {
    try {
      const e = await this.apiCall("GET", `vacancies/${r}`);
      if (e)
        return e.data;
      throw new Error();
    } catch (e) {
      return e;
    }
  }
  /* Member API */
  async getMembers(r, e, t, s) {
    try {
      let n = "";
      r && (n += `&page=${r}`), t && (n += `&per_page=${t}`), s && (n += `&show_all=${s}`);
      const a = await this.apiCall("GET", `members?divisions=${e}${n}`);
      if (a)
        return a;
    } catch (n) {
      console.log(n);
    }
  }
  async getMemberDetail(r) {
    try {
      const e = await this.apiCall("GET", `members/${r}`);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  async getMemberDivisions() {
    try {
      const r = await this.apiCall("GET", "members/divisions");
      if (r)
        return r;
    } catch (r) {
      return r;
    }
  }
  async deleteAccountMember() {
    try {
      const r = await this.apiCall("DELETE", "me");
      if (r)
        return r;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  /* Campaign API */
  async getCampaigns(r, e, t, s, n) {
    try {
      let a = "";
      r && (a += `&page=${r}`), e && (a += `&q=${e}`), s && (a += `&categories=${s}`), n && (a += `&date=${n}`);
      const i = await this.apiCall("GET", `campaigns?per_page=${t}${a}`);
      if (i)
        return i;
    } catch (a) {
      console.log(a);
    }
  }
  async getCampaignsFinished(r, e, t, s, n) {
    try {
      let a = "";
      r && (a += `&page=${r}`), e && (a += `&q=${e}`), s && (a += `&categories=${s}`), n && (a += `&date=${n}`);
      const i = await this.apiCall("GET", `campaigns/finished?per_page=${t}${a}`);
      if (i)
        return i;
    } catch (a) {
      console.log(a);
    }
  }
  async getCampaignDetail(r) {
    try {
      const e = await this.apiCall("GET", `campaigns/${r}`);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  async getCampaignCategories() {
    try {
      const r = await this.apiCall("GET", "campaigns/categories");
      if (r)
        return r;
    } catch (r) {
      return r;
    }
  }
  async CreateDonation({ amount: r, campaign_id: e, payment_method_id: t, name: s, phone: n, email: a, is_anonymous: i }) {
    try {
      const o = await this.apiCall("POST", "campaigns/donation", !0, {
        amount: r,
        campaign_id: e,
        payment_method_id: t,
        name: s,
        phone: n,
        email: a,
        is_anonymous: i
      });
      if (o)
        return o;
      throw new Error();
    } catch (o) {
      return o;
    }
  }
  /* Activities API */
  async getIdentifierActivities() {
    try {
      const r = await this.apiCall("GET", "activities/identifier");
      if (r)
        return r;
    } catch (r) {
      return r;
    }
  }
  async countView({ type: r, slug: e, identifier: t }) {
    try {
      const s = await this.apiCall("POST", `activities/${r}/views/${e}`, !0, {
        identifier: t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  async countShare({ type: r, slug: e, identifier: t }) {
    try {
      const s = await this.apiCall("POST", `activities/${r}/shares/${e}`, !0, {
        identifier: t
      });
      if (s)
        return s;
      throw new Error();
    } catch (s) {
      return s;
    }
  }
  /* E-commerce - Product API */
  async getProductsCommerce(r, e, t, s, n, a, i) {
    try {
      let o = "";
      r && (o += `&page=${r}`), e && (o += `&q=${e}`), s && (o += `&category=${s}`), i && (o += `&show_all=${i}`), n && (o += `&order=${n}`), a && (o += `&orderby=${a}`);
      const l = await this.apiCall("GET", `commerce/products?per_page=${t}${o}`, !1);
      if (l)
        return l;
    } catch (o) {
      return o;
    }
  }
  async getCategoriesProductCommerce() {
    try {
      const r = await this.apiCall("GET", "commerce/products/categories", !1);
      if (r)
        return r;
    } catch (r) {
      return r;
    }
  }
  async getProductCommerceDetail(r) {
    try {
      const e = await this.apiCall("GET", `commerce/products/${r}`, !1);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  /* E-commerce - Orders API */
  async CreateOrders({ name: r, email: e, phone: t, address: s, country: n, state: a, district: i, subdistrict: o, postcode: l, items: p, shipping_destination_id: y, shipping_courier: f, payment_method_id: w }) {
    try {
      const h = await this.apiCall("POST", "commerce/orders", !0, {
        name: r,
        email: e,
        phone: t,
        address: s,
        country: n,
        state: a,
        district: i,
        subdistrict: o,
        postcode: l,
        items: p,
        shipping_destination_id: y,
        shipping_courier: f,
        payment_method_id: w
      });
      if (h)
        return h;
      throw new Error();
    } catch (h) {
      return h;
    }
  }
  async getOrdersShipmentStates() {
    try {
      const r = await this.apiCall("GET", "commerce/orders/shipments/states", !1);
      if (r)
        return r;
    } catch (r) {
      return r;
    }
  }
  async getOrdersShipmentStateDetail(r) {
    try {
      const e = await this.apiCall("GET", `commerce/orders/shipments/states/${r}`, !1);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  async getOrdersShipmentDistricts(r) {
    try {
      let e = "";
      r && (e += `?state=${r}`);
      const t = await this.apiCall("GET", `commerce/orders/shipments/districts${e}`, !1);
      if (t)
        return t;
    } catch (e) {
      return e;
    }
  }
  async getOrdersShipmentDistrictDetail(r) {
    try {
      const e = await this.apiCall("GET", `commerce/orders/shipments/districts/${r}`, !1);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  async getOrdersShipmentSubdistricts(r) {
    try {
      let e = "";
      r && (e += `?district=${r}`);
      const t = await this.apiCall("GET", `commerce/orders/shipments/subdistricts${e}`, !1);
      if (t)
        return t;
    } catch (e) {
      return e;
    }
  }
  async getOrdersShipmentSubdistrictDetail(r) {
    try {
      const e = await this.apiCall("GET", `commerce/orders/shipments/subdistricts/${r}`, !1);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  async CheckOrderShipementCosts({ products: r, shipping_destination_id: e }) {
    try {
      const t = await this.apiCall("POST", "commerce/orders/shipments/costs", !0, {
        products: r,
        shipping_destination_id: e
      });
      if (t)
        return t;
      throw new Error();
    } catch (t) {
      return t;
    }
  }
  async getOrderDetail(r) {
    try {
      const e = await this.apiCall("GET", `commerce/orders/${r}`, !1);
      if (e)
        return e;
    } catch (e) {
      return e;
    }
  }
  /* Other API */
  async getMajorList() {
    try {
      const r = await this.apiCall("GET", "majors");
      if (r)
        return r.data;
      throw new Error();
    } catch (r) {
      return r;
    }
  }
  // NEWS V2
  async getPostsV2(r, e, t = "") {
    try {
      let s = "";
      r && (s += `&page=${r}`), e && (s += `&q=${e}`), t && (s += `&exclude=${t}`);
      const n = await this.apiCall("GET", `posts?pageNumber=8${s}`);
      if (n)
        return n;
    } catch (s) {
      console.log(s);
    }
  }
  async getLatestPostsV2(r, e = "") {
    try {
      let t = "";
      r && (t += `&page=${r}`), e && (t += `&exclude=${e}`);
      const s = await this.apiCall("GET", `posts?pageNumber=4${t}`);
      if (s)
        return s;
    } catch (t) {
      console.log(t);
    }
  }
  async getPostsDetailV2(r) {
    try {
      const e = await this.apiCall("GET", `posts/${r}`);
      if (e)
        return e.data;
    } catch (e) {
      return e;
    }
  }
  async getCategoriesPostV2(r, e, t, s, n = "") {
    try {
      let a = "";
      t && (a += `&categories=${t}`), r && (a += `&pageNumber=${r}`), e && (a += `&page=${e}`), s && (a += `&q=${s}`), n && (a += `&exclude=${n}`);
      const i = await this.apiCall("GET", `posts?${a}`);
      if (i)
        return i;
    } catch (a) {
      console.log(a);
    }
  }
  async getPostsCategoriesV2() {
    try {
      const r = "posts/categories", e = await this.apiCall("GET", `${r}`);
      if (e)
        return e.data;
    } catch (r) {
      return r;
    }
  }
  // Banner API V2
  async getBanners() {
    try {
      const r = await this.apiCall("GET", "banners");
      if (r)
        return r;
    } catch (r) {
      console.log(r);
    }
  }
}
export {
  d as default
};
